import { render, staticRenderFns } from "./InscricaoMunicipal.vue?vue&type=template&id=55280a59&"
import script from "./InscricaoMunicipal.vue?vue&type=script&lang=js&"
export * from "./InscricaoMunicipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports